import { ReactNode } from 'react';
import { List, ListItem, ListItemIcon, ListSubheader } from '@mui/material';
import ListItemText, { listItemTextClasses } from '@mui/material/ListItemText';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function PlanFeaturesList({
  title,
  items,
  icon,
}: {
  title?: string;
  icon?: ReactNode;
  items: ReactNode[];
}) {
  const Icon = icon ?? <CheckCircleIcon fontSize="small" />;

  return (
    <List
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
      subheader={
        <ListSubheader
          sx={(theme) => ({
            color: theme.palette.secondary.dark,
            fontSize: 14,
            lineHeight: '20px',
            fontWeight: 500,
          })}
          disableSticky
          disableGutters
          component="div"
        >
          {title}
        </ListSubheader>
      }
    >
      {items.map((value, index) => (
        <ListItem
          key={index}
          sx={{
            p: 0,
            alignItems: 'flex-start',
          }}
          disableGutters
        >
          <ListItemIcon
            sx={(theme) => ({
              color: theme.palette.primary.light,
              minWidth: 'auto',
              mr: '15px',
            })}
          >
            {Icon}
          </ListItemIcon>
          <ListItemText
            sx={(theme) => ({
              m: 0,
              [`& .${listItemTextClasses.primary}`]: {
                color: theme.palette.secondary.main,
                fontSize: 14,
                lineHeight: '20px',
              },
            })}
          >
            {value}
          </ListItemText>
        </ListItem>
      ))}
    </List>
  );
}
